<div class="card mt-3">
    <div class="card-body">
        <div class="row">
            <div class="col-md-8">
                <h5 class="card-title main-blue">
                    {{ "CampDetails.AdditionalOptions" | translate }}
                </h5>
            </div>
            <div class="col-md-4">
                @if (state.canEdit | async) {
                    <button
                        class="btn btn-success btn-action pull-right"
                        [disabled]="isAnyItemEdited"
                        hznTestId="options-add"
                        (click)="add()"
                    >
                        {{ "General.Add" | translate }}
                    </button>
                }
            </div>
        </div>
        <div class="card-text">
            <div class="card-text grid-table">
                <div class="row table-header-row">
                    <div class="col-md-2">
                        {{ "CampDetails.OptionType" | translate }}
                    </div>
                    <div class="col-md-2">
                        {{ "CampDetails.OptionName" | translate }}
                    </div>
                    <div class="col-md-4">
                        {{ "CampDetails.OptionDescription" | translate }}
                    </div>
                    <div class="col-md-2">
                        {{ "CampDetails.OptionSessionPrice" | translate }}
                    </div>
                    <div class="col-md-2"></div>
                </div>
                @for (option of form.controls.items["controls"]; track option) {
                    <div>
                        @if (!isEdited(option)) {
                            <app-option-details
                                [form]="option"
                                (removed)="onRemoved($event)"
                            ></app-option-details>
                        }
                        @if (isEdited(option)) {
                            <app-option-details-edit
                                [form]="option"
                                (canceled)="onCancel($event)"
                                [context]="context"
                            ></app-option-details-edit>
                        }
                    </div>
                }
            </div>
        </div>
    </div>
</div>
